import { makeTuple } from '/module/types';

export const JW_ACCOUNT_EDITIONS = makeTuple(
  'ads',
  'business',
  'developer',
  'enterprise',
  'free',
  'platinum',
  'premium',
  'starter',
  'trial',
  'unlimited',
  'pro',
);

export type JwAccountEdition = (typeof JW_ACCOUNT_EDITIONS)[number];

export const STARTER_EDITION_PRICE_ANNUAL = '10';
